import { useState, useEffect } from "react";
import { Card, CardTitle, CardSubtitle, CardBody } from "reactstrap";
import { FormattedMessage } from "react-intl";
import axios from "axios";
import pkg from "../../../package.json";
import { v4 as uuid } from "uuid";

export default function TeacherAboutUs() {
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.PUBLIC_URL}/settings.json?rndstr=${uuid()}`)
      .then((res) => {
        setContactInfo(res.data);
      });
  }, []);

  if (contactInfo === null) return <div></div>;
  return (
    <div className="animated fadeIn">
      <Card>
        <CardBody>
          <CardTitle>
            <FormattedMessage id="Contact" />
            <hr />
          </CardTitle>
          {contactInfo.contactPersons.map((person, i) => (
            <Card body key={i}>
              <CardSubtitle className="mb-2 text-muted" tag="h6">
                {person.name}
              </CardSubtitle>
              <p>
                <FormattedMessage id="Phone" />: {person.phone}
              </p>
              <p>
                <FormattedMessage id="Email" />:{" "}
                <a href={"mailto:" + person.email}>{person.email}</a>
              </p>
            </Card>
          ))}
          <Card body>
            <CardSubtitle className="mb-2 text-muted" tag="h6">
              <FormattedMessage id="Support" />
            </CardSubtitle>
            <p>
              <FormattedMessage id="Phone" />: {contactInfo.polContact.phone}
            </p>
            <p>
              <FormattedMessage id="Email" />:{" "}
              <a href={"mailto:" + contactInfo.polContact.email}>
                {contactInfo.polContact.email}
              </a>
            </p>
          </Card>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>
            <FormattedMessage id="Help" />
            <hr />
          </CardTitle>
          <a
            style={{ display: "block" }}
            href="http://ftp.pol.se/public/LearnWARE/manual_LWC.pdf"
          >
            <FormattedMessage id="ManualForLwc" />
          </a>
          <a
            style={{ display: "block" }}
            href="http://ftp.pol.se/public/LearnWARE/manual_APL_larare.pdf"
          >
            <FormattedMessage id="ManualForAPLTeacher" />
          </a>
          <a
            style={{ display: "block" }}
            href="http://ftp.pol.se/public/LearnWARE/manual_APL_elev.pdf"
          >
            <FormattedMessage id="ManualForAPLStudent" />
          </a>
          <a
            style={{ display: "block" }}
            href="http://ftp.pol.se/public/LearnWARE/manual_APL_handledare.pdf"
          >
            <FormattedMessage id="ManualForAPLSupervisor" />
          </a>
        </CardBody>
      </Card>

      <p style={{ marginTop: "-1rem" }}>
        <FormattedMessage id="Version" />: {pkg.version}
      </p>
    </div>
  );
}
